(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["vform"] = factory(require("axios"));
	else
		root["vform"] = factory(root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_21__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 22);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    form: {
      type: Object,
      required: true
    },

    dismissible: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    dismiss: function dismiss() {
      if (this.dismissible) {
        this.form.clear();
      }
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyY1xcY29tcG9uZW50c1xcQWxlcnQuanMiXSwibmFtZXMiOlsicHJvcHMiLCJmb3JtIiwidHlwZSIsIk9iamVjdCIsInJlcXVpcmVkIiwiZGlzbWlzc2libGUiLCJCb29sZWFuIiwiZGVmYXVsdCIsIm1ldGhvZHMiLCJkaXNtaXNzIiwiY2xlYXIiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUFlO0FBQ2JBLFNBQU87QUFDTEMsVUFBTTtBQUNKQyxZQUFNQyxNQURGO0FBRUpDLGdCQUFVO0FBRk4sS0FERDs7QUFNTEMsaUJBQWE7QUFDWEgsWUFBTUksT0FESztBQUVYQyxlQUFTO0FBRkU7QUFOUixHQURNOztBQWFiQyxXQUFTO0FBQ1BDLFdBRE8scUJBQ0k7QUFDVCxVQUFJLEtBQUtKLFdBQVQsRUFBc0I7QUFDcEIsYUFBS0osSUFBTCxDQUFVUyxLQUFWO0FBQ0Q7QUFDRjtBQUxNO0FBYkksQyIsImZpbGUiOiJBbGVydC5qcyIsInNvdXJjZVJvb3QiOiJDOi9Vc2Vycy9PdGluc29mdC9Db2RlL2dpdGh1Yi92Zm9ybSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcclxuICBwcm9wczoge1xyXG4gICAgZm9ybToge1xyXG4gICAgICB0eXBlOiBPYmplY3QsXHJcbiAgICAgIHJlcXVpcmVkOiB0cnVlXHJcbiAgICB9LFxyXG5cclxuICAgIGRpc21pc3NpYmxlOiB7XHJcbiAgICAgIHR5cGU6IEJvb2xlYW4sXHJcbiAgICAgIGRlZmF1bHQ6IHRydWVcclxuICAgIH1cclxuICB9LFxyXG5cclxuICBtZXRob2RzOiB7XHJcbiAgICBkaXNtaXNzICgpIHtcclxuICAgICAgaWYgKHRoaXMuZGlzbWlzc2libGUpIHtcclxuICAgICAgICB0aGlzLmZvcm0uY2xlYXIoKVxyXG4gICAgICB9XHJcbiAgICB9XHJcbiAgfVxyXG59XHJcbiJdfQ==

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AlertSuccess = exports.AlertErrors = exports.AlertError = exports.HasError4 = exports.HasError = exports.Form = undefined;

var _Form = __webpack_require__(10);

var _Form2 = _interopRequireDefault(_Form);

var _HasError = __webpack_require__(2);

var _HasError2 = _interopRequireDefault(_HasError);

var _HasError3 = __webpack_require__(14);

var _HasError4 = _interopRequireDefault(_HasError3);

var _Error = __webpack_require__(12);

var _Error2 = _interopRequireDefault(_Error);

var _Errors = __webpack_require__(13);

var _Errors2 = _interopRequireDefault(_Errors);

var _Success = __webpack_require__(15);

var _Success2 = _interopRequireDefault(_Success);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Form = _Form2.default;
exports.HasError = _HasError2.default;
exports.HasError4 = _HasError4.default;
exports.AlertError = _Error2.default;
exports.AlertErrors = _Errors2.default;
exports.AlertSuccess = _Success2.default;
exports.default = _Form2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyY1xcaW5kZXguanMiXSwibmFtZXMiOlsiRm9ybSIsIkhhc0Vycm9yIiwiSGFzRXJyb3I0IiwiQWxlcnRFcnJvciIsIkFsZXJ0RXJyb3JzIiwiQWxlcnRTdWNjZXNzIiwiZGVmYXVsdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7O1FBR0VBLEk7UUFDQUMsUTtRQUNBQyxTO1FBQ0FDLFU7UUFDQUMsVztRQUNBQyxZO1FBQ1FDLE8iLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiQzovVXNlcnMvT3RpbnNvZnQvQ29kZS9naXRodWIvdmZvcm0iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRm9ybSBmcm9tICcuL0Zvcm0nXG5pbXBvcnQgSGFzRXJyb3IgZnJvbSAnLi9jb21wb25lbnRzL0hhc0Vycm9yLnZ1ZSdcbmltcG9ydCBIYXNFcnJvcjQgZnJvbSAnLi9jb21wb25lbnRzL0hhc0Vycm9yNC52dWUnXG5pbXBvcnQgQWxlcnRFcnJvciBmcm9tICcuL2NvbXBvbmVudHMvRXJyb3IudnVlJ1xuaW1wb3J0IEFsZXJ0RXJyb3JzIGZyb20gJy4vY29tcG9uZW50cy9FcnJvcnMudnVlJ1xuaW1wb3J0IEFsZXJ0U3VjY2VzcyBmcm9tICcuL2NvbXBvbmVudHMvU3VjY2Vzcy52dWUnXG5cbmV4cG9ydCB7XG4gIEZvcm0sXG4gIEhhc0Vycm9yLFxuICBIYXNFcnJvcjQsXG4gIEFsZXJ0RXJyb3IsXG4gIEFsZXJ0RXJyb3JzLFxuICBBbGVydFN1Y2Nlc3MsXG4gIEZvcm0gYXMgZGVmYXVsdFxufVxuIl19

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(1);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _Alert2.default,

  name: 'alert-error',

  props: {
    message: {
      type: String,
      default: 'There were some problems with your input.'
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(1);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _Alert2.default,

  name: 'alert-errors',

  props: {
    message: {
      type: String,
      default: 'There were some problems with your input.'
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'has-error',

  props: {
    form: {
      type: Object,
      required: true
    },

    field: {
      type: String,
      required: true
    }
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HasError = __webpack_require__(2);

var _HasError2 = _interopRequireDefault(_HasError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _HasError2.default,

  name: 'has-error'

}; //
//
//
//

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(1);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _Alert2.default,

  name: 'alert-success',

  props: {
    message: {
      type: String,
      required: true
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Errors = function () {
  /**
   * Create a new error bag instance.
   */
  function Errors() {
    _classCallCheck(this, Errors);

    this.errors = {};
  }

  /**
   * Set the errors object.
   *
   * @param {Object}
   */


  _createClass(Errors, [{
    key: "set",
    value: function set(errors) {
      this.errors = errors;
    }

    /**
     * Get all the errors.
     *
     * @return {Object}
     */

  }, {
    key: "all",
    value: function all() {
      return this.errors;
    }

    /**
     * Determine if there is an error for the given field.
     *
     * @param  {String} field
     * @return {Boolean}
     */

  }, {
    key: "has",
    value: function has(field) {
      return this.errors.hasOwnProperty(field);
    }

    /**
     * Determine if there are any errors for the given fields.
     *
     * @param  {...String} fields
     * @return {Boolean}
     */

  }, {
    key: "hasAny",
    value: function hasAny() {
      var _this = this;

      for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
        fields[_key] = arguments[_key];
      }

      return fields.some(function (field) {
        return _this.has(field);
      });
    }

    /**
     * Determine if there are any errors.
     *
     * @return {Boolean}
     */

  }, {
    key: "any",
    value: function any() {
      return Object.keys(this.errors).length > 0;
    }

    /**
     * Get the error message for the given field.
     *
     * @param  String} field
     * @return {String|undefined}
     */

  }, {
    key: "get",
    value: function get(field) {
      if (this.has(field)) {
        var messages = this.errors[field];

        return Array.isArray(messages) ? messages[0] : messages;
      }
    }

    /**
     * Get the error message for the given fields.
     *
     * @param  {...String} fields
     * @return {Array}
     */

  }, {
    key: "only",
    value: function only() {
      var _this2 = this;

      var messages = [];

      for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        fields[_key2] = arguments[_key2];
      }

      fields.forEach(function (field) {
        var message = _this2.get(field);

        if (message) {
          messages.push(message);
        }
      });

      return messages;
    }

    /**
     * Get all the errors in a flat array.
     *
     * @return {Array}
     */

  }, {
    key: "flatten",
    value: function flatten() {
      return Object.values(this.errors).reduce(function (a, b) {
        return a.concat(b);
      }, []);
    }

    /**
     * Clear one or all error fields.
     *
     * @param {String|undefined} field
     */

  }, {
    key: "clear",
    value: function clear(field) {
      var _this3 = this;

      var errors = {};

      if (field) {
        Object.keys(this.errors).forEach(function (key) {
          if (key !== field) {
            errors[key] = _this3.errors[key];
          }
        });
      }

      this.set(errors);
    }
  }]);

  return Errors;
}();

exports.default = Errors;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyY1xcRXJyb3JzLmpzIl0sIm5hbWVzIjpbIkVycm9ycyIsImVycm9ycyIsImZpZWxkIiwiaGFzT3duUHJvcGVydHkiLCJmaWVsZHMiLCJzb21lIiwiaGFzIiwiT2JqZWN0Iiwia2V5cyIsImxlbmd0aCIsIm1lc3NhZ2VzIiwiQXJyYXkiLCJpc0FycmF5IiwiZm9yRWFjaCIsIm1lc3NhZ2UiLCJnZXQiLCJwdXNoIiwidmFsdWVzIiwicmVkdWNlIiwiYSIsImIiLCJjb25jYXQiLCJrZXkiLCJzZXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7SUFBcUJBLE07QUFDbkI7OztBQUdBLG9CQUFlO0FBQUE7O0FBQ2IsU0FBS0MsTUFBTCxHQUFjLEVBQWQ7QUFDRDs7QUFFRDs7Ozs7Ozs7O3dCQUtLQSxNLEVBQVE7QUFDWCxXQUFLQSxNQUFMLEdBQWNBLE1BQWQ7QUFDRDs7QUFFRDs7Ozs7Ozs7MEJBS087QUFDTCxhQUFPLEtBQUtBLE1BQVo7QUFDRDs7QUFFRDs7Ozs7Ozs7O3dCQU1LQyxLLEVBQU87QUFDVixhQUFPLEtBQUtELE1BQUwsQ0FBWUUsY0FBWixDQUEyQkQsS0FBM0IsQ0FBUDtBQUNEOztBQUVEOzs7Ozs7Ozs7NkJBTW1CO0FBQUE7O0FBQUEsd0NBQVJFLE1BQVE7QUFBUkEsY0FBUTtBQUFBOztBQUNqQixhQUFPQSxPQUFPQyxJQUFQLENBQVk7QUFBQSxlQUFTLE1BQUtDLEdBQUwsQ0FBU0osS0FBVCxDQUFUO0FBQUEsT0FBWixDQUFQO0FBQ0Q7O0FBRUQ7Ozs7Ozs7OzBCQUtPO0FBQ0wsYUFBT0ssT0FBT0MsSUFBUCxDQUFZLEtBQUtQLE1BQWpCLEVBQXlCUSxNQUF6QixHQUFrQyxDQUF6QztBQUNEOztBQUVEOzs7Ozs7Ozs7d0JBTUtQLEssRUFBTztBQUNWLFVBQUksS0FBS0ksR0FBTCxDQUFTSixLQUFULENBQUosRUFBcUI7QUFDbkIsWUFBTVEsV0FBVyxLQUFLVCxNQUFMLENBQVlDLEtBQVosQ0FBakI7O0FBRUEsZUFBT1MsTUFBTUMsT0FBTixDQUFjRixRQUFkLElBQTBCQSxTQUFTLENBQVQsQ0FBMUIsR0FBd0NBLFFBQS9DO0FBQ0Q7QUFDRjs7QUFFRDs7Ozs7Ozs7OzJCQU1pQjtBQUFBOztBQUNmLFVBQU1BLFdBQVcsRUFBakI7O0FBRGUseUNBQVJOLE1BQVE7QUFBUkEsY0FBUTtBQUFBOztBQUdmQSxhQUFPUyxPQUFQLENBQWUsaUJBQVM7QUFDdEIsWUFBTUMsVUFBVSxPQUFLQyxHQUFMLENBQVNiLEtBQVQsQ0FBaEI7O0FBRUEsWUFBSVksT0FBSixFQUFhO0FBQ1hKLG1CQUFTTSxJQUFULENBQWNGLE9BQWQ7QUFDRDtBQUNGLE9BTkQ7O0FBUUEsYUFBT0osUUFBUDtBQUNEOztBQUVEOzs7Ozs7Ozs4QkFLVztBQUNULGFBQU9ILE9BQU9VLE1BQVAsQ0FBYyxLQUFLaEIsTUFBbkIsRUFBMkJpQixNQUEzQixDQUFrQyxVQUFDQyxDQUFELEVBQUlDLENBQUo7QUFBQSxlQUFVRCxFQUFFRSxNQUFGLENBQVNELENBQVQsQ0FBVjtBQUFBLE9BQWxDLEVBQXlELEVBQXpELENBQVA7QUFDRDs7QUFFRDs7Ozs7Ozs7MEJBS09sQixLLEVBQU87QUFBQTs7QUFDWixVQUFNRCxTQUFTLEVBQWY7O0FBRUEsVUFBSUMsS0FBSixFQUFXO0FBQ1RLLGVBQU9DLElBQVAsQ0FBWSxLQUFLUCxNQUFqQixFQUF5QlksT0FBekIsQ0FBaUMsZUFBTztBQUN0QyxjQUFJUyxRQUFRcEIsS0FBWixFQUFtQjtBQUNqQkQsbUJBQU9xQixHQUFQLElBQWMsT0FBS3JCLE1BQUwsQ0FBWXFCLEdBQVosQ0FBZDtBQUNEO0FBQ0YsU0FKRDtBQUtEOztBQUVELFdBQUtDLEdBQUwsQ0FBU3RCLE1BQVQ7QUFDRDs7Ozs7O2tCQW5Ia0JELE0iLCJmaWxlIjoiRXJyb3JzLmpzIiwic291cmNlUm9vdCI6IkM6L1VzZXJzL090aW5zb2Z0L0NvZGUvZ2l0aHViL3Zmb3JtIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgY2xhc3MgRXJyb3JzIHtcclxuICAvKipcclxuICAgKiBDcmVhdGUgYSBuZXcgZXJyb3IgYmFnIGluc3RhbmNlLlxyXG4gICAqL1xyXG4gIGNvbnN0cnVjdG9yICgpIHtcclxuICAgIHRoaXMuZXJyb3JzID0ge31cclxuICB9XHJcblxyXG4gIC8qKlxyXG4gICAqIFNldCB0aGUgZXJyb3JzIG9iamVjdC5cclxuICAgKlxyXG4gICAqIEBwYXJhbSB7T2JqZWN0fVxyXG4gICAqL1xyXG4gIHNldCAoZXJyb3JzKSB7XHJcbiAgICB0aGlzLmVycm9ycyA9IGVycm9yc1xyXG4gIH1cclxuXHJcbiAgLyoqXHJcbiAgICogR2V0IGFsbCB0aGUgZXJyb3JzLlxyXG4gICAqXHJcbiAgICogQHJldHVybiB7T2JqZWN0fVxyXG4gICAqL1xyXG4gIGFsbCAoKSB7XHJcbiAgICByZXR1cm4gdGhpcy5lcnJvcnNcclxuICB9XHJcblxyXG4gIC8qKlxyXG4gICAqIERldGVybWluZSBpZiB0aGVyZSBpcyBhbiBlcnJvciBmb3IgdGhlIGdpdmVuIGZpZWxkLlxyXG4gICAqXHJcbiAgICogQHBhcmFtICB7U3RyaW5nfSBmaWVsZFxyXG4gICAqIEByZXR1cm4ge0Jvb2xlYW59XHJcbiAgICovXHJcbiAgaGFzIChmaWVsZCkge1xyXG4gICAgcmV0dXJuIHRoaXMuZXJyb3JzLmhhc093blByb3BlcnR5KGZpZWxkKVxyXG4gIH1cclxuXHJcbiAgLyoqXHJcbiAgICogRGV0ZXJtaW5lIGlmIHRoZXJlIGFyZSBhbnkgZXJyb3JzIGZvciB0aGUgZ2l2ZW4gZmllbGRzLlxyXG4gICAqXHJcbiAgICogQHBhcmFtICB7Li4uU3RyaW5nfSBmaWVsZHNcclxuICAgKiBAcmV0dXJuIHtCb29sZWFufVxyXG4gICAqL1xyXG4gIGhhc0FueSAoLi4uZmllbGRzKSB7XHJcbiAgICByZXR1cm4gZmllbGRzLnNvbWUoZmllbGQgPT4gdGhpcy5oYXMoZmllbGQpKVxyXG4gIH1cclxuXHJcbiAgLyoqXHJcbiAgICogRGV0ZXJtaW5lIGlmIHRoZXJlIGFyZSBhbnkgZXJyb3JzLlxyXG4gICAqXHJcbiAgICogQHJldHVybiB7Qm9vbGVhbn1cclxuICAgKi9cclxuICBhbnkgKCkge1xyXG4gICAgcmV0dXJuIE9iamVjdC5rZXlzKHRoaXMuZXJyb3JzKS5sZW5ndGggPiAwXHJcbiAgfVxyXG5cclxuICAvKipcclxuICAgKiBHZXQgdGhlIGVycm9yIG1lc3NhZ2UgZm9yIHRoZSBnaXZlbiBmaWVsZC5cclxuICAgKlxyXG4gICAqIEBwYXJhbSAgU3RyaW5nfSBmaWVsZFxyXG4gICAqIEByZXR1cm4ge1N0cmluZ3x1bmRlZmluZWR9XHJcbiAgICovXHJcbiAgZ2V0IChmaWVsZCkge1xyXG4gICAgaWYgKHRoaXMuaGFzKGZpZWxkKSkge1xyXG4gICAgICBjb25zdCBtZXNzYWdlcyA9IHRoaXMuZXJyb3JzW2ZpZWxkXVxyXG5cclxuICAgICAgcmV0dXJuIEFycmF5LmlzQXJyYXkobWVzc2FnZXMpID8gbWVzc2FnZXNbMF0gOiBtZXNzYWdlc1xyXG4gICAgfVxyXG4gIH1cclxuXHJcbiAgLyoqXHJcbiAgICogR2V0IHRoZSBlcnJvciBtZXNzYWdlIGZvciB0aGUgZ2l2ZW4gZmllbGRzLlxyXG4gICAqXHJcbiAgICogQHBhcmFtICB7Li4uU3RyaW5nfSBmaWVsZHNcclxuICAgKiBAcmV0dXJuIHtBcnJheX1cclxuICAgKi9cclxuICBvbmx5ICguLi5maWVsZHMpIHtcclxuICAgIGNvbnN0IG1lc3NhZ2VzID0gW11cclxuXHJcbiAgICBmaWVsZHMuZm9yRWFjaChmaWVsZCA9PiB7XHJcbiAgICAgIGNvbnN0IG1lc3NhZ2UgPSB0aGlzLmdldChmaWVsZClcclxuXHJcbiAgICAgIGlmIChtZXNzYWdlKSB7XHJcbiAgICAgICAgbWVzc2FnZXMucHVzaChtZXNzYWdlKVxyXG4gICAgICB9XHJcbiAgICB9KVxyXG5cclxuICAgIHJldHVybiBtZXNzYWdlc1xyXG4gIH1cclxuXHJcbiAgLyoqXHJcbiAgICogR2V0IGFsbCB0aGUgZXJyb3JzIGluIGEgZmxhdCBhcnJheS5cclxuICAgKlxyXG4gICAqIEByZXR1cm4ge0FycmF5fVxyXG4gICAqL1xyXG4gIGZsYXR0ZW4gKCkge1xyXG4gICAgcmV0dXJuIE9iamVjdC52YWx1ZXModGhpcy5lcnJvcnMpLnJlZHVjZSgoYSwgYikgPT4gYS5jb25jYXQoYiksIFtdKVxyXG4gIH1cclxuXHJcbiAgLyoqXHJcbiAgICogQ2xlYXIgb25lIG9yIGFsbCBlcnJvciBmaWVsZHMuXHJcbiAgICpcclxuICAgKiBAcGFyYW0ge1N0cmluZ3x1bmRlZmluZWR9IGZpZWxkXHJcbiAgICovXHJcbiAgY2xlYXIgKGZpZWxkKSB7XHJcbiAgICBjb25zdCBlcnJvcnMgPSB7fVxyXG5cclxuICAgIGlmIChmaWVsZCkge1xyXG4gICAgICBPYmplY3Qua2V5cyh0aGlzLmVycm9ycykuZm9yRWFjaChrZXkgPT4ge1xyXG4gICAgICAgIGlmIChrZXkgIT09IGZpZWxkKSB7XHJcbiAgICAgICAgICBlcnJvcnNba2V5XSA9IHRoaXMuZXJyb3JzW2tleV1cclxuICAgICAgICB9XHJcbiAgICAgIH0pXHJcbiAgICB9XHJcblxyXG4gICAgdGhpcy5zZXQoZXJyb3JzKVxyXG4gIH1cclxufVxyXG4iXX0=

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__(21);

var _axios2 = _interopRequireDefault(_axios);

var _Errors = __webpack_require__(9);

var _Errors2 = _interopRequireDefault(_Errors);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Form = function () {
  /**
   * Create a new form instance.
   *
   * @param {Object} data
   */
  function Form() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Form);

    this.busy = false;
    this.successful = false;
    this.errors = new _Errors2.default();
    this.originalData = (0, _util.deepCopy)(data);

    Object.assign(this, data);
  }

  /**
   * Get the form data.
   *
   * @return {Object}
   */


  _createClass(Form, [{
    key: 'data',
    value: function data() {
      var _this = this;

      var data = {};

      this.keys().forEach(function (key) {
        data[key] = _this[key];
      });

      return data;
    }

    /**
     * Get the form data keys.
     *
     * @return {Array}
     */

  }, {
    key: 'keys',
    value: function keys() {
      return Object.keys(this).filter(function (key) {
        return !Form.ignore.includes(key);
      });
    }

    /**
     * Start processing the form.
     */

  }, {
    key: 'startProcessing',
    value: function startProcessing() {
      this.errors.clear();
      this.busy = true;
      this.successful = false;
    }

    /**
     * Finish processing the form.
     */

  }, {
    key: 'finishProcessing',
    value: function finishProcessing() {
      this.busy = false;
      this.successful = true;
    }

    /**
     * Clear the form errors.
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.errors.clear();
      this.successful = false;
    }

    /**
     * Reset the form fields.
     */

  }, {
    key: 'reset',
    value: function reset() {
      var _this2 = this;

      Object.keys(this).filter(function (key) {
        return !Form.ignore.includes(key);
      }).forEach(function (key) {
        _this2[key] = (0, _util.deepCopy)(_this2.originalData[key]);
      });
    }

    /**
     * Submit the from via a GET request.
     *
     * @param  {String} url
     * @return {Promise}
     */

  }, {
    key: 'get',
    value: function get(url) {
      return this.submit('get', url);
    }

    /**
     * Submit the from via a POST request.
     *
     * @param  {String} url
     * @return {Promise}
     */

  }, {
    key: 'post',
    value: function post(url) {
      return this.submit('post', url);
    }

    /**
     * Submit the from via a PATCH request.
     *
     * @param  {String} url
     * @return {Promise}
     */

  }, {
    key: 'patch',
    value: function patch(url) {
      return this.submit('patch', url);
    }

    /**
     * Submit the from via a PUT request.
     *
     * @param  {String} url
     * @return {Promise}
     */

  }, {
    key: 'put',
    value: function put(url) {
      return this.submit('put', url);
    }

    /**
     * Submit the from via a DELETE request.
     *
     * @param  {String} url
     * @return {Promise}
     */

  }, {
    key: 'delete',
    value: function _delete(url) {
      return this.submit('delete', url);
    }

    /**
     * Submit the form data via an HTTP request.
     *
     * @param  {String} method (get, post, patch, put)
     * @param  {String} url
     * @param  {Object} config (axios config)
     * @return {Promise}
     */

  }, {
    key: 'submit',
    value: function submit(method, url) {
      var _this3 = this;

      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.startProcessing();

      url = this.route(url);
      var data = this.data();

      if ((0, _util.hasFile)(data)) {
        data = (0, _util.toFormData)(data);
      }

      if (method === 'get') {
        data = { params: data };
      }

      return new Promise(function (resolve, reject) {
        _axios2.default.request(_extends({ url: url, method: method, data: data }, config)).then(function (response) {
          _this3.finishProcessing();

          resolve(response);
        }).catch(function (error) {
          _this3.busy = false;

          if (error.response) {
            _this3.errors.set(_this3.extractErrors(error.response));
          }

          reject(error);
        });
      });
    }

    /**
     * Extract the errors from the response object.
     *
     * @param  {Object} response
     * @return {Object}
     */

  }, {
    key: 'extractErrors',
    value: function extractErrors(response) {
      if (!response.data || _typeof(response.data) !== 'object') {
        return { error: Form.errorMessage };
      }

      if (response.data.errors) {
        return _extends({}, response.data.errors);
      }

      if (response.data.message) {
        return { error: response.data.message };
      }

      return _extends({}, response.data);
    }

    /**
     * Get a named route.
     *
     * @param  {String} name
     * @return {Object} parameters
     * @return {String}
     */

  }, {
    key: 'route',
    value: function route(name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var url = name;

      if (Form.routes.hasOwnProperty(name)) {
        url = decodeURI(Form.routes[name]);
      }

      if ((typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) !== 'object') {
        parameters = { id: parameters };
      }

      Object.keys(parameters).forEach(function (key) {
        url = url.replace('{' + key + '}', parameters[key]);
      });

      return url;
    }
  }]);

  return Form;
}();

Form.routes = {};
Form.errorMessage = 'Something went wrong. Please try again.';
Form.ignore = ['busy', 'successful', 'errors', 'originalData'];

exports.default = Form;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.deepCopy = deepCopy;
exports.hasFile = hasFile;
exports.toFormData = toFormData;
/**
 * Deep copy the given object.
 *
 * @param  {Object} obj
 * @return {Object}
 */
function deepCopy(obj) {
  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return obj;
  }

  var copy = Array.isArray(obj) ? [] : {};

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key]);
  });

  return copy;
}

/**
 * Determinte if the given object has any files.
 *
 * @param  {Object} obj
 * @return {Boolean}
 */
function hasFile(obj) {
  return Object.keys(obj).some(function (key) {
    return obj[key] instanceof Blob || obj[key] instanceof FileList;
  });
}

/**
 * Convert the given object to a FormData instance.
 *
 * @param  {Object} obj
 * @return {FormData}
 */
function toFormData(obj) {
  var data = new FormData();

  Object.keys(obj).forEach(function (key) {
    var value = obj[key];

    if (value instanceof FileList) {
      for (var i = 0; i < value.length; i++) {
        data.append(key + '[]', value.item(i));
      }
    } else {
      data.append(key, value);
    }
  });

  return data;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(17),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form.errors.has(_vm.field)) ? _c('div', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.form.errors.get(_vm.field))
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form.errors.any()) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.form.errors.flatten()), function(error) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(error)
      }
    })
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form.successful) ? _c('div', {
    staticClass: "alert alert-success"
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form.errors.has(_vm.field)) ? _c('div', {
    staticClass: "form-control-feedback",
    domProps: {
      "innerHTML": _vm._s(_vm.form.errors.get(_vm.field))
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form.errors.any()) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.form.errors.has('error')) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.form.errors.get('error'))
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vform.js